import { createStructuredSelector } from 'reselect';
import {
  ENT_SUPPLIER_USER_LIST, ENT_SUPPLIER_USER_LIST_SUCCESS, ENT_SUPPLIER_USER_LIST_ERROR,
  ENT_SUPPLIER_USER_PAGE_SET,
  ENT_SUPPLIER_USER_ADD, ENT_SUPPLIER_USER_ADD_SUCCESS, ENT_SUPPLIER_USER_ADD_ERROR,
  ENT_SUPPLIER_USER_ADD_CHANGE,
  ENT_SUPPLIER_USER_DETAIL, ENT_SUPPLIER_USER_DETAIL_SUCCESS, ENT_SUPPLIER_USER_DETAIL_ERROR,
  ENT_SUPPLIER_USER_UPDATE, ENT_SUPPLIER_USER_UPDATE_SUCCESS, ENT_SUPPLIER_USER_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'ent_supplier_user';

export const EnterpriseSupplierUserList = (page, num_page, orderBy, filters) => ({ type: ENT_SUPPLIER_USER_LIST, payload: { page, num_page, orderBy, filters } });
export const EnterpriseSupplierUserListSuccess = (data) => ({ type: ENT_SUPPLIER_USER_LIST_SUCCESS, payload: data });
export const EnterpriseSupplierUserListError = (error) => ({ type: ENT_SUPPLIER_USER_LIST_ERROR, payload: error });
export const EnterpriseSupplierUserPageSet = (data) => ({ type: ENT_SUPPLIER_USER_PAGE_SET, payload: data });
export const EnterpriseSupplierUserAddChangeSet = (data) => ({ type: ENT_SUPPLIER_USER_ADD_CHANGE, payload: data });
export const EnterpriseSupplierUserAdd = (data) => ({ type: ENT_SUPPLIER_USER_ADD, payload: data });
export const EnterpriseSupplierUserAddSuccess = (message) => ({ type: ENT_SUPPLIER_USER_ADD_SUCCESS, payload: message });
export const EnterpriseSupplierUserAddError = (error) => ({ type: ENT_SUPPLIER_USER_ADD_ERROR, payload: error });
export const EnterpriseSupplierUserDetail = (data) => ({ type: ENT_SUPPLIER_USER_DETAIL, payload: data });
export const EnterpriseSupplierUserDetailSuccess = (data) => ({ type: ENT_SUPPLIER_USER_DETAIL_SUCCESS, payload: data });
export const EnterpriseSupplierUserDetailError = (error) => ({ type: ENT_SUPPLIER_USER_DETAIL_ERROR, payload: error });
export const EnterpriseSupplierUserUpdate = (data) => ({ type: ENT_SUPPLIER_USER_UPDATE, payload: data });
export const EnterpriseSupplierUserUpdateSuccess = (message) => ({ type: ENT_SUPPLIER_USER_UPDATE_SUCCESS, payload: message.message });
export const EnterpriseSupplierUserUpdateError = (error) => ({ type: ENT_SUPPLIER_USER_UPDATE_ERROR, payload: error });

const ent_supplier_user = (state) => state[NAME];
export const EnterpriseSupplierUserSelector = createStructuredSelector({ ent_supplier_user });
